/* eslint-disable react/prop-types */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
    ArrowRightOutlined,
    PlusOutlined,
    CalendarOutlined,
    ShareAltOutlined,
    SafetyOutlined,
    MoreOutlined,
} from "@ant-design/icons";
import AllActionsModal from "./AllActionsModal";
import useActionGroups from "./useActionGroups";
import cn from "../../../utilities/tailwind-merge";

/* A 2x2 grid on phones, a single row of five from `sm` up. */
const TILE_CLASS =
    "flex w-full min-w-0 flex-col items-center justify-center gap-2 rounded-2xl border border-gray-200 bg-white px-2 py-3 text-center text-xs font-medium leading-tight text-gray-800 shadow-sm transition-all hover:-translate-y-0.5 hover:border-[#5D5DF6] hover:bg-[#F5F5FF] hover:shadow-md sm:py-4 sm:text-sm md:py-5";

const TILE_ICON_CLASS =
    "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#F0F0FE] text-[#5D5DF6] text-lg";

const ActionTile = ({ icon, label, onClick, className }) => (
    <button type="button" onClick={onClick} className={cn(TILE_CLASS, className)}>
        <span className={TILE_ICON_CLASS}>{icon}</span>
        <span className="min-w-0">{label}</span>
    </button>
);

const QuickActionsGrid = () => {
    const { t } = useTranslation("dashboard");
    const history = useHistory();
    const [isAllActionsOpen, setIsAllActionsOpen] = useState(false);
    const { actionGroups, goToAddVehicle, handleCopyLink } = useActionGroups();

    return (
        <div className="shrink-0">
            <div className="mb-3 flex items-center justify-between gap-3">
                <h2 className="text-lg font-semibold text-gray-900">{t("quickActions")}</h2>
                {/* On phones "More" lives here rather than as a fifth tile, which
                    would sit alone on its own row of the 2x2 grid. */}
                <button
                    type="button"
                    onClick={() => setIsAllActionsOpen(true)}
                    className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#5D5DF6] sm:hidden">
                    {t("more")}
                    <ArrowRightOutlined className="text-[11px]" />
                </button>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-5 sm:gap-3">
                <ActionTile icon={<PlusOutlined />} label={t("addAVehicle")} onClick={goToAddVehicle} />
                <ActionTile
                    icon={<CalendarOutlined />}
                    label={t("viewAllReservations")}
                    onClick={() => history.push("/reservations")}
                />
                <ActionTile icon={<ShareAltOutlined />} label={t("copyWebsiteLink")} onClick={handleCopyLink} />
                <ActionTile
                    icon={<SafetyOutlined />}
                    label={t("manageInsuranceProducts")}
                    onClick={() => history.push("/insurance")}
                />
                <ActionTile
                    icon={<MoreOutlined />}
                    label={t("more")}
                    onClick={() => setIsAllActionsOpen(true)}
                    className="hidden sm:flex"
                />
            </div>
            <AllActionsModal
                open={isAllActionsOpen}
                onClose={() => setIsAllActionsOpen(false)}
                actionGroups={actionGroups}
            />
        </div>
    );
};

export default QuickActionsGrid;
